<template src="./companyinspectionsetting.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";

  export default {
    components: {},
    filters: {},
    data() {
      return {
        FleetSubscription: {},
        CountCustomInspection: 0,
        ShowLoader: false,
        Editmode: false,
        Submitted: false,
        CategorySubmitted: false,
        CompanyInspections: [],
        Categories: [],
        VehicleClasses: [],
        Classes: [],
        Category: 0,
        ClassID: 3,
        AddClassId:0,
        ClassSubmitted:false,
        ShowCategoryUpdateModel:false,
        ShowAddCategoryModel:true,
        CategoryTitle: "",
        AddCategory: {
          title:''
        },
        SubmitCategory: {},
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Settings";
      this.GetCompanySubscription();
      this.GetVehicleDefaultClasses();
      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
    },

    methods: {
      EditCategory(Category){
        this.SubmitCategory = Category;
        this.SubmitCategory.name = Category.title;
        this.ShowCategoryUpdateModel = true;
      },
      updateCategory() {
        var error = false;
        var errorStr = "";
        if (!this.SubmitCategory.name) {
          error = true;
          errorStr += "<li>Please Enter Category Title</li>";
        }

        if (error == true) {
          this.$swal("Following Error Found!", errorStr, "error").then(
            () => {}
          );
        } else {
          if(this.CategoryTitle == this.SubmitCategory.title){
            this.CategoryTitle = this.SubmitCategory.name;
          }
          this.SubmitCategory.title = this.SubmitCategory.name;
          this.$swal({
            title: "Updating Category...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          Axios.post(Endpoints.VehicleInspections.CategoryUpdate, {
            token: localStorage.getItem("token"),
            ...this.SubmitCategory,
          }).then((Response) => {
            if (Response?.data?.success == true) {
              this.ShowCategoryUpdateModel = false;
              this.$swal("Category Updated Successfully", "", "success").then(
                () => {}
              );
            } else {
              this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
            }
          });
        }
      },
      addNewCategory() {
        var error = false;
        var errorStr = "";
        if (!this.AddCategory.title) {
          error = true;
          errorStr += "<li>Please Enter Category Title</li>";
        }

        if (error == true) {
          this.$swal("Following Error Found!", errorStr, "error").then(
            () => {}
          );
        } else {
          this.CategorySubmitted = true;
          this.$swal({
            title: "Adding Category...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          this.AddCategory.vehicle_class_id = this.ClassID;
          Axios.post(Endpoints.VehicleInspections.CategoryAdd, {
            token: localStorage.getItem("token"),
            ...this.AddCategory,
          }).then((Response) => {
            this.CategorySubmitted = false;
            if (Response?.data?.success == true) {
              this.ShowAddCategoryModel = false;
              this.$swal("Category Added Successfully", "", "success").then(
                () => {
                  this.AddCategory.title = "";
                }
              );
              this.GetCategory();
            } else {
              this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
            }
          });
        }
      },
      GetVehicleDefaultClasses(){
          var obj = { token: localStorage.getItem("token"), simple_list:false,  type:'fleet_inspection_category' };
          Axios.post(Endpoints.VehicleChecks.GetVehicleClassList, obj).then((Response) => {
            if (Response?.data?.success) {
              this.Classes = Response.data.records;
            }
          });        
      },
      GetCategory() {
        Axios.post(Endpoints.VehicleInspections.GetCategoriesList, {
          token: localStorage.getItem("token"),
          class_id: this.ClassID,
        }).then((Response) => {
          if (Response?.data?.success) {
            this.Categories = Response.data.InspectionCategories;
            this.Categories.forEach((element, index) => {
              if (index == 0) {
                this.Category = element.id;
                var catID = element.id;
                this.GetCompanyInspections(catID);
                this.CategoryTitle = element.title;
              }
            });
          }
        });
      },
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isHGV = FleetSubscriptionModules.HGV;
        if (isHGV) {
          this.GetVehicleClasses();
        } else {
          this.$router.push("/settings");
        }
      },
      GetVehicleClasses(ClassID = 0) {
        if (localStorage.getItem("InspectionsClasses")) {
          this.VehicleClasses = JSON.parse(
            localStorage.getItem("InspectionsClasses")
          );          
        } else {
          Axios.post(Endpoints.VehicleInspections.GetVehicleClasses, {
            token: localStorage.getItem("token"),
          }).then((Response) => {
            if (Response?.data?.success) {
              this.VehicleClasses = Response.data.records;
            }
          });
        }

        if(ClassID > 0){
          this.GetClassCategoriesList(ClassID);
        }else{
          this.VehicleClasses.forEach((element, index) => {
            if (index == 0) {
              this.GetClassCategoriesList(element.id);
            }
          });
        }
        
      },
      EnableEditMode() {
        this.Editmode = true;
      },
      DisableEditMode() {
        this.Editmode = false;
      },
      GetCompanyInspections(catID) {
        this.ShowLoader = true;
        Axios.post(Endpoints.VehicleInspections.GetCompanyInspections, {
          token: localStorage.getItem("token"),
          fleet_inspection_category_id: catID,
        }).then((Response) => {
          this.ShowLoader = false;
          this.CompanyInspections = Response.data.CompanyInspections;
          if (typeof this.CompanyInspections[0] != "undefined") {
            this.CompanyInspections[0]["required"] = true;
          }
          this.CountCompanyCustomInspections();
        });
      },
      CountCompanyCustomInspections() {
        this.CountCustomInspection = this.CompanyInspections.length;
      },
      SaveCompanyInspections() {
        var error = false;
        this.CompanyInspections.forEach((element) => {
          if (element.id == 0) {
            if (element.name == "") {
              error = true;
              this.$swal("Please Enter Inspection Name", "", "error");
              return true;
            }
          }
        });
        if (!error) {
          this.Submitted = true;
          this.CompanyInspections.fleet_inspection_category_id = this.Category;
          Axios.post(Endpoints.VehicleInspections.SaveCompanyInspections, {
            token: localStorage.getItem("token"),
            CompanyInspections: this.CompanyInspections,
          }).then((Response) => {
            this.Submitted = false;
            this.GetCompanyInspections(this.Category);
            this.$swal(
              "Vehicle Inspections Saved Successfully",
              "",
              "success"
            ).then(() => {
              this.GetInspectionsList(this.Category);
            });
          });
        }
      },
      DeleteCompanyInspections(checkid) {
        this.$swal({
          title: "Are you sure You want to delete this Check List?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal({
              title: "Deleting...",
              text: "Please wait...",
              imageUrl: require("@/assets/images/LoadingTwo.gif"),
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.VehicleInspections.DeleteCompanyInspections, {
              token: localStorage.getItem("token"),
              id: checkid,
            }).then((Response) => {
              this.CompanyInspections.forEach((value, index) => {
                if (value.id == checkid) {
                  this.CompanyInspections.splice(index, 1);
                }
              });
              this.CountCompanyCustomInspections();
              this.$swal(
                "Inspection Record Deleted Successfully",
                "",
                "success"
              ).then(() => {
                if(checkid > 0){
                  this.GetInspectionsList(this.Category);
                }
              });
            });
          }
        });
      },
      deleteCategory(catid) {
        this.$swal({
          title: "Are you sure You want to delete this Category?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal({
              title: "Deleting...",
              text: "Please wait...",
              imageUrl: require("@/assets/images/LoadingTwo.gif"),
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.VehicleInspections.DeleteCategory, {
              token: localStorage.getItem("token"),
              id: catid,
            }).then((Response) => {
              if(Response?.data?.success){
              this.CountCompanyCustomInspections();
              this.GetVehicleDefaultClasses();
              this.$swal(
                Response?.data?.message || "Something went wrong",
                "",
                "success"
              ).then(() => {
                this.GetCategory();
              });
            }else{
              this.$swal(
                Response?.data?.message || "Something went wrong",
                "",
                "error"
              ).then(() => {
                
              });
            }
            });
          }
        });
      },
      AddCustomVehicleInspection() {
        if (
          this.FleetSubscription &&
          this.FleetSubscription.pmi_check_count_per_category >
            this.CountCustomInspection
        ) {
          this.Editmode = true;
          var obj = {
            custom: 1,
            id: 0,
            name: "",
            fleet_inspection_category_id: this.Category,
            position: this.CompanyInspections.length + 1,
            required: 1,
            status: 1,
          };
          this.CompanyInspections.push(obj);
          this.CountCompanyCustomInspections();
        } else {
          this.$swal(
            "You have reached your subscription's maximum allowed PMI checks. Please contact us to add more checks",
            "",
            "error"
          );
        }

      },
      GetInspectionsList(catID, catTitle = null) {
        this.CompanyInspections = [];
        this.Category = catID;
        this.Editmode = false;
        this.GetCompanyInspections(catID);
        $(".leftnav").removeClass("btn-primary");
        $("#catid" + catID).addClass("btn-primary");
        if(catTitle != "" && catTitle != null){
          this.CategoryTitle = catTitle;
        }
      },
      GetClassCategoriesList(classID) {
        this.CompanyInspections = [];
        this.Categories = [];
        this.ClassID = classID;
        setTimeout(() => {
          $(".class-links").removeClass("active");
          $("#class_id" + classID).addClass("active");
        }, 500);
        this.Editmode = false;
        this.GetCategory();
      },
      addNewClass() {
        var error = false;
        if (this.AddClassId <= 0) {
          error = true;
          this.$swal("Please select template", "", "error");
          return true;
        }
        if (!error) {
          this.ClassSubmitted = true;
          Axios.post(Endpoints.VehicleInspections.AddNewClass, {
            token: localStorage.getItem("token"),
            AddClassId: this.AddClassId,
          }).then((Response) => {
            if (Response?.data?.success == true) {
                localStorage.removeItem('InspectionsClasses');
                this.GetVehicleClasses(this.AddClassId);
                this.GetVehicleDefaultClasses();
                this.AddClassId = 0;
                this.ClassSubmitted = false;
                this.$root.$emit("reloadInspectionClass");
                $('#add-new-class .btn-primary').trigger('click');
                this.$swal(
                  "Vehicle Inspection Template  Added Successfully",
                  "",
                  "success"
                ).then(() => {});
            } else {
              this.$swal(Response.data.records, "", "error").then(() => {});
            }
          });
        }
      },
      usedClassAlert() {
        this.$swal(
          "Cannot Delete Template",
          "(This template has been used in inspection check)",
          "error"
        );
        return true;
      },
      deleteClass(classid) {
        this.$swal({
          title: "Are you sure You want to delete this Class?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal({
              title: "Deleting...",
              text: "Please wait...",
              imageUrl: require("@/assets/images/LoadingTwo.gif"),
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.VehicleInspections.DeleteClass, {
              token: localStorage.getItem("token"),
              id: classid,
            }).then((Response) => {
              if (Response?.data?.success) {
                this.$root.$emit("reloadVehicleClass");
                this.$swal(
                  Response?.data?.message || "Something went wrong",
                  "",
                  "success"
                ).then(() => {});
                localStorage.removeItem('InspectionsClasses');
                this.GetVehicleClasses();
                this.GetVehicleDefaultClasses();
              } else {
                this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
              }
            });
          }
        });
      },
    },
  };
</script>

<style scoped>
.tableheading-2{
  display: inline-block;
  margin-bottom: 5px;
  vertical-align: sub;
}
  .activeAdd {
    text-align: center;
    background: #8f4f88 !important;
    color: #fff;
    overflow: hidden;
  }
  .text-primary {
    color: #8f4f88 !important;
  }
  .deleteClass {
    font-size: 16px;
    margin: 2px 0 0 10px;
  }
  .editClass {
    font-size: 16px;
    margin: 2px 0 0 10px;
    color: #8F4F88 !important;
  }

 .inspections-categories a{
    display: inline-block;
    width: 80%;
    text-align: left;
    padding: 5px;
  }
  .inspections-categories .leftnav {
    padding: 0px;
  }
  .inspections-categories .editClass, .inspections-categories .deleteClass{
    font-weight: normal;
    cursor: pointer;
    position: absolute;
    right: 28px;
  }
  .inspections-categories .editClass{
    right: 48px;
  }
  .inspections-categories .btn-primary span, .inspections-categories .btn-primary .editClass{
    color: #FFF !important;
    font-weight: normal;
  }
  .inspections-categories .btn-primary .deleteClass{
    color: #FFF !important;
  }
  .inspections-categories  span{
    font-weight: normal;
  }
  .pl-10{
    padding-left: 10px !important;
  }
  .f-right{
    float: right !important;
  }
  .text-danger {
    color: #dc3545 !important;
}
.cat-links .deleteClass[data-v-7e741893] {
    font-size: 16px;
    margin: 2px 0 0 20px;
}
</style>